// src/pages/supplier/PayoutsPage.jsx
import { useQuery } from '@tanstack/react-query'
import { supplierPayoutsApi } from '../../api/services'
import { Card, CardBody, StatusBadge, PageSpinner } from '../../components/common/ui'

export default function PayoutsPage() {
  const { data, isLoading } = useQuery({ queryKey: ['supplier-payouts'], queryFn: () => supplierPayoutsApi.index() })
  if (isLoading) return <PageSpinner />
  const { payouts = {}, summary = {} } = data?.data?.data || {}
  const list = payouts.data || []

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6">Payouts</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
        {[
          ['Pending', `₹${Number(summary.pending_payout || 0).toLocaleString('en-IN')}`],
          ['Paid this month', `₹${Number(summary.paid_this_month || 0).toLocaleString('en-IN')}`],
          ['Total paid', `₹${Number(summary.total_paid || 0).toLocaleString('en-IN')}`],
        ].map(([l, v]) => (
          <div key={l} className="bg-white border border-border rounded-xl p-4">
            <p className="text-xs text-muted">{l}</p>
            <p className="text-xl font-bold text-gray-900">{v}</p>
          </div>
        ))}
      </div>
      <div className="space-y-3">
        {list.map(p => (
          <Card key={p.id}>
            <CardBody className="flex justify-between items-center">
              <div>
                <p className="font-bold text-sm">₹{Number(p.amount || p.net_payout).toLocaleString('en-IN')}</p>
                <p className="text-xs text-muted">{new Date(p.created_at).toLocaleDateString('en-IN')} · {p.transfer_mode}</p>
              </div>
              <StatusBadge status={p.status} />
            </CardBody>
          </Card>
        ))}
        {list.length === 0 && <p className="text-sm text-muted text-center py-8">No payouts yet.</p>}
      </div>
    </div>
  )
}
